import { Component, Injectable } from '@angular/core';
import { CodeSnippet } from './code-snippet.interface';
import { Observable, Subject, lastValueFrom } from 'rxjs';
import { AddDatapointSnippet } from './add-datapoint.snippet';


@Component({
    selector: 'write-datapoint-snippet',
    template: `
        <clx-popover
            #editorwindow
            *ngIf="isDialogOpen"
            [minWidth]="300"
            [maxWidth]="800"
            class="popup"
            height="auto"
            width="auto"
            title="Write Datapoint"
            i18n-title="@@script-editor.snippet.write-datapoint.popup.title"
            [(visible)]="isDialogOpen"
            (visibleChange)="visibilityChanged($event)"
        >
            <div
                class="error message"
                *ngIf="error"
                i18n="@@script-editor.snippet.popup.message.plant-missing"
            >Please choose a plant/system before adding a datapoint</div>

            <clx-row
                has="full-size-columns big-layout">
                <clx-item>
                <clx-label>Variable name (OOP)</clx-label>
                <clx-checkbox name="OOP mode"
                    #oopMode
                    [(value)]="useOOPMode"
                    selected="true"></clx-checkbox>
                    <clx-input
                        name="varname"
                        #varname
                        value="plant"
                        [disabled]="oopMode.value ? null : true"
                    >
                        <clx-validation type="required"></clx-validation>
                    </clx-input>
                </clx-item>
            </clx-row>

            <clx-datapoint-selection
                *ngIf="!error && plantId"
                [plantId]="plantId"
                [selected]="plantId"
                show="viewNode"
                mode="viewNode"
                name="selectDatapoint"
                (selection)="selectDatapoint($event, {oopMode: oopMode.value, varname: varname.value })"
            ></clx-datapoint-selection>

            <clx-datapoint-selection
                *ngIf="!error && systemId"
                [systemId]="systemId"
                [selected]="systemId"
                show="viewNode"
                mode="systemPlant"
                name="selectDatapoint2"
                (selection)="selectDatapoint($event, {oopMode: oopMode.value, varname: varname.value })"
            ></clx-datapoint-selection>
        </clx-popover>
    
    `,
    standalone: false
})
export class WriteDatapointSnippet extends AddDatapointSnippet implements CodeSnippet{

    text: string = $localize`:@@script-editor.snippet.writevalue:writevalue()`;

    async insert(): Promise<string> {

        this.useOOPMode = this.data.oop;

        this.plantId = null;
        this.systemId = null;

        this.subject = new Subject();
        this.observable = this.subject.asObservable();
        this.isDialogOpen = true;
        this.error = true;

        if (this.data?.plantInput?.value) {
            this.plantId = this.data.plantInput.value;
        }
        else if (this.data?.systemInput?.value) {
            this.systemId = this.data.systemInput.value;
        }
        else {
            return '';
        }

        this.error = false;
        const value = await lastValueFrom(this.observable);
        this.isDialogOpen = false;

        if (value.data.oopMode) {

            if (value)
                return `    -- write datapoint '${value.dpname}' value from variable v
    ${value.data.varname}${value.dpd.path} = v
`;
        }
        else {
            if (value) {
                if (this.data.mode != "S")
                    return `    -- set the value of datapoint '${value.dpname}'
        setvalue("${value.datapointId}", value)
    `;

                return `    -- set the value of datapoint '${value.dpname}' on ${value.systemPlantName}
        setvalue("${value.systemPlantName}", "${value.datapointId}", value)
    `;
            }
        }

        return '';
    }

}